import React, { useEffect, useState } from 'react';
import { getReviews } from '../api/apiendpoint';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ReviewList.css';
import Image from '../images/icon/person.png'; // Placeholder image

const ReviewList = ({ username = '' }) => {
  const [reviews, setReviews] = useState([]);
  const [error, setError] = useState('');
  const [visibleCount, setVisibleCount] = useState(3);

 

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const data = await getReviews(username);
        setReviews(data);
      } catch (err) {
        setError(err.message || 'Failed to load reviews');
      }
    };
    fetchReviews();
  }, [username]);

  const handleViewMore = () => {
    setVisibleCount((prev) => Math.min(prev + 3, reviews.length));
  };

  const handleViewLess = () => {
    setVisibleCount(3);
  };

  const visibleReviews = reviews.slice(0, visibleCount);

  return (
    <section style={{ color: '#000' }}>
      <div className="container py-5">
        <div className="row d-flex justify-content-center">
          <div className="col-md-10 col-xl-8 text-center">
            <h3 className="fw-bold mb-4">Testimonials</h3>
            <p className="mb-4 pb-2 mb-md-5 pb-md-0">
              Hear from our customers. Your feedback helps us grow and improve.
            </p>
            <Link to="/create-review" className="btn btn-dark shadow mb-4">
              Leave a Review
            </Link>
          </div>
        </div>

        {error && <p className="text-danger text-center">{error}</p>}
        {reviews.length === 0 ? (
          <p className="text-center">No reviews yet.</p>
        ) : (
          <div className="row text-center">
            {visibleReviews.map((review) => (
              <div key={review.id} className="col-md-4 mb-4">
                <div className="card h-100">
                  <div className="card-body py-4 mt-2">
                    <div className="d-flex justify-content-center mb-4">
                      <img
                        src={review.image ||  Image }
                        className="rounded-circle shadow-1-strong"
                        width="100"
                        height="100"
                        alt="Reviewer"
                      />
                    </div>
                    <h5 className="fw-bold">{review.name}</h5>
                    <h6 className="fw-bold my-3">{review.position || 'Customer'}</h6>
                    <ul className="list-unstyled d-flex justify-content-center mb-2">
                      {[...Array(5)].map((_, i) => (
                        <li key={i}>
                          <FaStar
                            className="fa-sm"
                            color={i < review.rating ? '#ffc107' : '#e4e5e9'}
                          />
                        </li>
                      ))}
                    </ul>
                    <p className="mb-2">
                      <FaQuoteLeft className="me-2" />
                      {review.content}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {reviews.length > 3 && (
          <div className="text-center mt-4">
            {visibleCount < reviews.length ? (
              <button className="btn btn-outline-dark me-2" onClick={handleViewMore}>
                View More
              </button>
            ) : (
              <button className="btn btn-outline-secondary" onClick={handleViewLess}>
                View Less
              </button>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default ReviewList;
